import { Container, WrapperInCall } from './styled';
import { BsFillCameraVideoFill } from 'react-icons/bs';

const STATUS = {
  IN_CALL: 1,
  INVITED: 2,
  NOT_SUPPORTED: 3
}

const STATUS_TEXT = {
  IN_CALL: 'Em chamada...',
  INVITED: 'Convite recebido',
  NOT_SUPPORTED: 'Não disponível'
}


export function VideoCallStatus({ dataCall }) {

  if (dataCall === "IN CALL" || dataCall === "INVITE" || !dataCall) {
    return (
      <Container>
        <WrapperInCall variant={STATUS["NOT_SUPPORTED"]}>
          <div className="call-icon-wrapper">
            <BsFillCameraVideoFill className="call-icon" />
          </div>
          <span className="call-text">
            {STATUS_TEXT["NOT_SUPPORTED"]}
          </span>
        </WrapperInCall>
      </Container>
    )
  }

  const data = JSON.parse(dataCall);

  return (
    <Container>
      <WrapperInCall variant={STATUS[data?.status ?? "NOT_SUPPORTED"]}>
        <div className="call-icon-wrapper">
          <BsFillCameraVideoFill className="call-icon" />
        </div>
        <span className="call-text">
          {STATUS_TEXT[data?.status ?? "NOT_SUPPORTED"]}
        </span>
      </WrapperInCall>
    </Container>
  )
}